<template>
  <div>
    <i-button v-if="list.length === 0"
              html-type="button"
              @click="add(-1)"
              style="width: 100%">{{$t('pages_combo_rule_list_290')}}</i-button>
    <div class="rule-item"
         v-for="(item, index) in list"
         :key="index">
        <el-select
          v-model="item.fresh_product_id"
          filterable
          remote
          :placeholder="$t('pages_combo_rule_list_291')"
          :remote-method="remoteMethod"
          @change="(e) => changeProduct(e, index)"
          >
          <el-option
            v-for="i in products"
            :value="i.id"
            :key="i.id"
            :label="i.name"
          >
          </el-option>
        </el-select>
      <!-- <i-input :value="item.enough"
               @on-change="(e) => changeEnough(e, index)" /> 元， -->
      <!-- <span class="prefix">111</span> -->
      <i-input :value="item.quantity" style="width: 100px;"
               @on-change="(e) => changeQuantity(e, index)" /> <span class="suffix">{{$t('pages_combo_rule_list_292')}}</span>
      <span class="handlers">
        <a v-if="list.length < 5"
           @click.prevent="add(index)">{{$t('pages_combo_rule_list_290')}}</a>
        <a type="text"
           @click.prevent="remove(index)"
           style="margin-left: 8px">{{$t('libs_table_render_70')}}</a>
      </span>
    </div>
  </div>
</template>

<script>
import i18n from '../../locales/index'

import { mapActions, mapGetters, mapMutations } from 'vuex'
export default {
  props: ['value'],
  data () {
    return {
      searchData: {
        query: ''
      },
      loading: false
    }
  },
  computed: {
    list () {
      return this.value || [];
    },
    ...mapGetters('product', ['products']),
  },
  mounted () {
    this.index()
  },
  methods: {
    ...mapActions('product', ['index']),
    ...mapMutations('product', ['changeQuery', 'resetQuery']),
    remoteMethod (query) {
      if (query !== '') {
        this.searchData.query = query
        this.searchBtnClick()
      }
    },
    searchBtnClick () {
      // this.resetQuery()
      this.changeQuery(this.searchData)
      this.index()
    },
    changeProduct (value, index) {
      const selectedProduct = this.products.find(item => item.id === value)
      const copy = this.value.slice();
      copy[index] = {
        ...copy[index],
        fresh_product_id: parseInt(value) || '',
        fresh_product_name: selectedProduct.name
      }
      this.$emit('input', copy)
    },
    changeQuantity (e, index) {
      const copy = this.value ? this.value.slice() : [];
      copy[index] = {
        ...copy[index],
        quantity: parseInt(e.target.value) || '',
      }
      this.$emit('input', copy)
    },
    add (index) {
      const copy = this.value ? this.value.slice() : [];
      copy.splice(index + 1, 0, { fresh_product_id: null, quantity: 0 })
      this.$emit('input', copy)
    },
    remove (index) {
      const copy = this.value ? this.value.slice() : [];
      copy.splice(index, 1)
      this.$emit('input', copy)
    },
  }
}
</script>

<style lang="scss" scoped>
.rule-item {
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  div {
    margin-right: 5px;
  }
  > span {
    &.prefix {
      flex: 0 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.suffix {
      flex: 0 0 40px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    &.handlers {
      flex: 0 0 100px;
      display: flex;
      align-items: center;
      justify-content: center;
    }
  }
}
</style>
